import { render, staticRenderFns } from "./MiniGameResources.vue?vue&type=template&id=92bdb216&scoped=true"
import script from "./MiniGameResources.vue?vue&type=script&lang=js"
export * from "./MiniGameResources.vue?vue&type=script&lang=js"
import style0 from "./MiniGameResources.vue?vue&type=style&index=0&id=92bdb216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bdb216",
  null
  
)

export default component.exports